import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'principalAndInterest',
    label: 'Principal & Interest',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'secondaryFinancing',
    label: 'Secondary Financing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'pmi', label: 'Mortgage Insurance', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'pmiManualUpdate', label: 'MI Override', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'monthlyHomeownersInsurance',
    label: 'Homeowners Insurance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownersInsurancePolicyDueDate',
    label: 'Homeowners Insurance Policy Due Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'associationFeesAmount', label: 'HOA Dues', levelType: AutoLockFormsLevelType.FIELD },
];

export const proposedPropertyExpensesForm = {
  name: FormNames.PROPOSED_PROPERTY_EXPENSES,
  label: 'Proposed Property Expenses',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
